var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.178 29.57c1.85 0 2.812-.93 3.258-1.839.209-.423.304-.842.325-1.16h-2.904c-.097-5.552-.232-17.352 0-20.14.232-2.789-1.581-4.002-2.517-4.26-4.875.064-15.396.155-18.495 0-2.183-.11-3.149.93-3.506 1.936a3.11 3.11 0 0 0-.174.861 2.657 2.657 0 0 0 0 .301H8.17V26.57c0 2.168 1.806 2.904 2.71 3h15.298zm1.836-23.044c-.212 2.54-.11 12.973-.015 18.881h3l-.08 1.237a4.45 4.45 0 0 1-1.085 2.568c-.777.886-1.98 1.52-3.657 1.52H10.818l-.062-.006a4.506 4.506 0 0 1-2.31-.984c-.813-.671-1.439-1.717-1.439-3.173V6.43H1.07l-.064-1.094c-.045-.77.15-1.893.917-2.825.813-.987 2.13-1.593 3.98-1.5 3.052.152 13.527.063 18.42-.002l.165-.002.16.044c1.353.373 3.654 2.015 3.366 5.476zm-10.647.485h-7.165V5.85h7.165v1.16zM10.3 12.047v-1.162h14.135v1.162H10.3zm0 2.904h12.2V13.79H10.3v1.16zm13.36 2.905H10.3v-1.162h13.36v1.162zM10.3 19.598v1.162h14.135v-1.162H10.3zm5.518 4.26h-5.616v-1.162h5.616v1.162z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/PEOPLE.c2de0ed31a31a55db1e2a1dc2dc0b862.svg";
export { ForwardRef as ReactComponent };